module.exports = __webpack_public_path__ + "static/media/delete.f7fc5c04.svg";